import { Component, h, Prop, Event, EventEmitter, State } from "@stencil/core";
import { Element } from "@stencil/core";

@Component({
  tag: "datagrid-filter-checkbox",
  shadow: false,
})
export class DatagridFilterCheckbox {
  @Prop() grid_id!: string;
  /**
   * The field name to filter on.
   */
  @Prop() field!: string;
  /**
   * The label for the filter.
   */
  @Prop() label!: string;
  /**
   * The options for the filter, in JSON format.
   * Example: '[{"label": "Option 1", "value": "option1"}, {"label": "Option 2", "value": "option2"}]'
   */
  @Prop() options!: string;
 /**
   * The initial value for the filter.
   */
  @Prop() initialValue?: string;
  /**
   * The type of filter.
   * This is used to identify the filter type in the event emitted.
   * Example: "datagrid-filter-checkbox"
   * This is useful for identifying the filter type in the event handler.
   * This is optional and can be used for custom filter types.
   * Example: "custom-filter-type"
   */
  @Event() filterChanged: EventEmitter<{
    grid_id: string;
    field: string;
    value: any;
    type: string;
  }>;

  @Element() el!: HTMLElement;

  @State() selectedValues: string[] = [];
  @State() selectedValue: any = "";

  handleCheckboxChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const value = target.value;

    let updatedValues = [...this.selectedValues];

    if (target.checked) {
      updatedValues.push(value);
    } else {
      updatedValues = updatedValues.filter((v) => v !== value);
    }

    this.selectedValues = updatedValues;
    this.emitFilterChange();
    // Vue 2: emit 'input' event
    this.el.dispatchEvent(new CustomEvent('input', {
      bubbles: true,
      composed: true,
      detail: this.selectedValues,
    }));

    // Vue 3: emit 'update:modelValue' event
    this.el.dispatchEvent(new CustomEvent('update:modelValue', {
      bubbles: true,
      composed: true,
      detail: this.selectedValues,
    }));
  }

  emitFilterChange() {
    this.filterChanged.emit({
      grid_id: this.grid_id,
      field: this.field,
      value: this.selectedValues,
      type: "datagrid-filter-checkbox",
    });
  }

  get parsedOptions(): { label: string; value: string }[] {
    try {
      const parsed = this.options ? JSON.parse(this.options) : [];
      if (Array.isArray(parsed)) {
        return parsed.map((opt) =>
          typeof opt === "string" ? { label: opt, value: opt } : opt
        );
      }
      return [];
    } catch (e) {
      console.error("🚨 Error parsing options:", this.options, e);
      return [];
    }
  }

  render() {
    return (
      <div class="datagrid-filter-checkbox">
        <div class="checkbox-filter">
          {this.parsedOptions.map((option) => (
            <div class="checkbox-item" style={{ marginBottom: "10px" }}>
              <signet-checkbox
                label={option.label}
                value={option.value}
                checked={this.selectedValues.includes(option.value)}
                onChange={(e) => this.handleCheckboxChange(e)}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }
}
